import { Box, Button, ButtonGroup, Collapse, Stack } from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import Icons from "../../../assets/js/Icons"
import { Fragment } from "react"

function SidebarMenu({
  menu,
  activeIndex,
  setActiveIndex,
  index,
  sidebarDeActive,
}) {
  const { pathname } = useLocation()
  const isActive = activeIndex === index

  return (
    <Box>
      {menu?.menus ? (
        <Fragment>
          {menu?.name === "services" ? (
            <ButtonGroup>
              <Button
                sx={{
                  px: 1,
                  border: "none",
                  fontWeight: "500",
                  letterSpacing: "0",
                  position: "relative",
                  textTransform: "capitalize",
                  ".MuiButton-icon": { m: "0" },
                  ":hover": { color: "primary.main" },
                  // fontSize: { xs: 15, md: 20, xxl: 20 },
                  color: pathname === "/services" ?
                    "primary.main" : "dark.main",
                }}
                disableRipple
                to="/services"
                LinkComponent={Link}
                onClick={() => {
                  sidebarDeActive()
                  setActiveIndex(null)
                }}
              >
                Services
              </Button>
              <Button
                sx={{
                  px: "0",
                  border: "none",
                  fontSize: "20px",
                  color: "dark.main",
                  minWidth: "auto !important",
                  ":hover": { color: "primary.main" },
                }}
                size="small"
                disableRipple
                onClick={() => setActiveIndex(isActive ? null : index)}
              >
                <Icons.ArrowDown1 />
              </Button>
            </ButtonGroup>
          ) : (
            <Button
              color="dark"
              disableRipple
              endIcon={<Icons.ArrowDown1 />}
              sx={{ textTransform: "capitalize" }}
              onClick={() => setActiveIndex(isActive ? null : index)}
            >
              {menu?.name}
            </Button>
          )}
        </Fragment>
      ) : (
        <Button
          color="dark"
          disableRipple
          to={menu?.path}
          LinkComponent={Link}
          onClick={() => {
            sidebarDeActive()
            setActiveIndex(null)
          }}
          sx={{ textTransform: "capitalize" }}
        >
          {menu?.name}
        </Button>
      )}
      {menu?.menus && (
        <Collapse in={isActive} timeout={300} unmountOnExit>
          <Stack spacing={1}>
            {menu?.menus?.map((item, i) => (
              <Button
                key={i}
                sx={{
                  justifyContent: { xs: "left", sm: "left" },
                  pl: { xs: 4, sm: 4 },
                }}
                color="dark"
                disableRipple
                to={item?.path}
                LinkComponent={Link}
                onClick={() => {
                  sidebarDeActive()
                  setActiveIndex(null)
                }}
              >
                {item?.name}
              </Button>
            ))}
          </Stack>
        </Collapse>
      )}
    </Box>
  )
}

export default SidebarMenu
